import { uuid } from './util/uuid'

import { network } from './network'

import { clickMsg, clickMsgFn } from './clickMsg'

import { loadMsg, loadMsgFn } from './loadMsg'

import { exception as resException } from './resource'

import { normalException, unhandledRejection } from './runtime'

import { hashChange } from './hashChange'
import { hackPushState } from './hashChange'

import { olPerf } from './performance'

import { instantUploader } from './uploader/instant'

import { cacheUploader } from './uploader/cache'

import { init } from './xes-common/init'

import { vuePluginInstall, vueException } from './plugins/vue'

import { retryToLog } from './util/retry-to-log'

/**
 * XesLoggerSDK function
 * Example: `new XesLoggerSDK()`
 * @param {Object} logger options
 * XesLoggerSDK is constructor function
 */
var XesLoggerSDK = function (opts, Vue) {
  XesLoggerSDK.fn.setOption(opts)

  XesLoggerSDK.fn.init(Vue)
}

/**
 * XesLoggerSDK prototype object
 */
XesLoggerSDK.fn = XesLoggerSDK.prototype = {
  constructor: XesLoggerSDK
}

/**
 * XesLoggerSDK set options function
 * Example: `XesLoggerSDK.fn.setOption(opts)`
 * @param {Object} logger options
 */
XesLoggerSDK.fn.setOption = function (opts) {
  /*
   * 处理options默认值与外传options
   */
  var self = this
  opts = opts || {}
  this.opts = {
    baseURL: '',
    /** 禁用任何发给 a.gif 的请求 */
    disableAgif: !!opts.disableAgif,
    common: {},
    cacheUploader: {},
    network: {},
    runtime: {},
    performance: {},
    clickMsg: {},
    loadMsg: {},
    pvMsg: {},
    resource: {},
    hashchange: {},
    vue: {},
    trace: {},
    appid: {},
    param: {},
    uv: '',
    // 2.0.8 到 2.1.8过滤接口使用，舍弃
    // 只有配置的域名的接口才可以上报，其他的接口不上报
    // traceFilter: ['xueersi.com', 'xesv5.com'],
    // 屏蔽接口请求，此配置的接口，不上报日志中心 比如：localhost, c.gif, a.gif
    // 通过去掉traceFilter和添加ignoreAjaxFilter来支持过滤接口和支持集团其他域名上报的目的
    ignoreAjaxFilter: [ 'localhost', 'c.gif', 'a.gif', 'b.gif' ]
  }

  if (opts.common && opts.common.eventid) {
    this.opts.common = opts.common
    // this.opts.common.eventid = opts.common.eventid
  } else {
    throw new Error('请填写{common.eventid}字段')
  }

  if (opts.baseURL) {
    this.opts.baseURL = opts.baseURL.match('/$')
      ? opts.baseURL
      : `${opts.baseURL}/`
  } else {
    // XesLoggerSDK default option `baseURL`
    this.opts.baseURL = 'https://dj.xesimg.com/appid/'
  }

  this.opts.uv = opts.uv
  // appid支持object与string两种配置类型
  // 2.X版本后不采用appkey鉴权改为referer鉴权
  // 设置appid为string类型，可使用户无需关注appkey与referer，sdk将自动获取document.domain作为referer
  const appid = opts.appid || ''
  if (typeof appid === 'object') {
    // 当配置的appid为object时，直接存入
    this.opts.appid = appid
  } else if (typeof appid === 'string') {
    // 当配置的appid为string时，自动解析成object进行存入
    // 例如：appid: 1000001 将被自动解析成 appid: { 当前domain:1000001  }
    this.opts.appid[window.document.domain] = { appid }
  }

  // 判断appid配置是否可用
  // 若当前域名下不存在appid配置，将会直接导致日志上报不成功
  if (!(this.opts.appid && (window.document.domain in this.opts.appid))) {
    console.log('fe_log_sdk: 没有找到可用的appid配置, 您的appid配置为:', appid)
  }

  if (opts.param) {
    this.opts.param = opts.param
  }

  // if (opts.traceFilter && opts.traceFilter instanceof Array) {
  //   this.opts.traceFilter = this.opts.traceFilter.concat(opts.traceFilter)
  // }

  if (opts.ignoreAjaxFilter && opts.ignoreAjaxFilter instanceof Array) {
    this.opts.ignoreAjaxFilter = this.opts.ignoreAjaxFilter.concat(opts.ignoreAjaxFilter);
  }

  var setOptionOrDefault = function (space, key, defaultValue) {
    if (opts[space] && (opts[space][key] !== undefined)) {
      self.opts[space][key] = opts[space][key]
    } else {
      self.opts[space][key] = defaultValue
    }
  }

  setOptionOrDefault('network', 'open', true)

  setOptionOrDefault('network', 'sample', 1)

  setOptionOrDefault('network', 'stopAbortLog', false)

  setOptionOrDefault('clickMsg', 'open', true)

  setOptionOrDefault('loadMsg', 'open', true)

  setOptionOrDefault('pvMsg', 'open', true)

  setOptionOrDefault('runtime', 'open', true)

  setOptionOrDefault('runtime', 'sample', 1)

  setOptionOrDefault('resource', 'open', true)

  setOptionOrDefault('resource', 'sample', 1)

  setOptionOrDefault('hashchange', 'open', true)

  setOptionOrDefault('hashchange', 'pvid', 'hash')

  setOptionOrDefault('hashchange', 'pageuid', {})

  setOptionOrDefault('hashchange', 'loadParam', {})

  setOptionOrDefault('performance', 'open', true)

  setOptionOrDefault('performance', 'sample', 1)

  setOptionOrDefault('cacheUploader', 'interval', 10000)

  setOptionOrDefault('cacheUploader', 'batch', 5)

  setOptionOrDefault('vue', 'errorHandler', false)

  setOptionOrDefault('trace', 'open', false)
}

/**
 * XesLoggerSDK init function
 * Example: `XesLoggerSDK.fn.init()`
 * Init function set instance variable and install logger modules
 */
XesLoggerSDK.fn.init = function (Vue) {
  // var self = this;
  window.__XES_LOG__ = this;

  var opts = this.opts

  this._state = {
    pvid: uuid() || '',
    ajaxid: 0,
    logorder: 1
  }

  init()

  this.instantUploader = instantUploader(this._state, opts)

  this.cacheUploader = cacheUploader(this._state, opts)

  if (opts.vue.errorHandler) {
    vueException(this.cacheUploader, Vue)
  }

  if (opts.network.open) {
    network(this.cacheUploader, this._state, opts)
  }

  if (opts.clickMsg.open) {
    clickMsg(this.instantUploader, opts)
    this.clickMsg = clickMsgFn(this.instantUploader, opts)
  }

  loadMsg(this.instantUploader, opts)

  this.loadMsg = loadMsgFn(this.instantUploader, opts)

  if (opts.resource.open && Math.random() < opts.resource.sample) {
    resException(this, opts)
  }

  if (opts.runtime.open && Math.random() < opts.runtime.sample) {
    normalException(this.cacheUploader)
    unhandledRejection(this.cacheUploader)
  }

  if (opts.hashchange.open) {
    hashChange(this.instantUploader, this._state, opts)
  }
  hackPushState(this.instantUploader, this._state, opts)

  if (opts.performance.open && Math.random() < opts.performance.sample) {
    olPerf(this.cacheUploader)
  }

  retryToLog()
}

XesLoggerSDK.install = vuePluginInstall

export default XesLoggerSDK
